// extracted by mini-css-extract-plugin
export default {"cell":"TableSelectAllCell_cell__agtwr"};